export const setPlaybook = playbook => ({
    type: 'setPlaybook',
    payload: playbook,
})

export const resetPlaybook = () => ({
    type: 'resetPlaybook',
})
